import React from 'react';
import { useTranslation } from 'react-i18next';

const Contact: React.FC = () => {
  // @ts-ignore
  const { t } = useTranslation();

  return (
    <div className="page-container">
      {/* @ts-ignore */}
      <h1 className="page-title">{t('contact.title')}</h1>
      <div className="contact-simple">
        <div className="contact-card">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">📍</div>
              {/* @ts-ignore */}
              <p>{t('contact.address')}</p>
            </div>
            <div className="info-item">
              <div className="info-icon">📧</div>
              <p>info@matrixjp.com</p>
            </div>
            
            <div className="contact-action">
              <a href="mailto:info@matrixjp.com" className="email-button">
                {/* @ts-ignore */}
                {t('contact.submit')}
              </a>
            </div>
          </div>
        </div>
        
        <div className="map-container">
          <iframe 
            title="Matrix Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.7480391155542!2d139.74070999354377!3d35.66554998719761!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b9c2ef8ddd9%3A0x37e9a758cd6d8edd!2sKamiyacho%20MT%20Building!5e0!3m2!1sen!2sjp!4v1709826051871!5m2!1sen!2sjp" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen={true} 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact; 